export const SoilThresholds: Record<
  string,
  { label: string; min: number; max: number; color: string }[]
> = {
  pH: [
    { label: "Too acidic (<5.5)", min: -Infinity, max: 5.5, color: "#d73027" },
    { label: "Moderate (5.5–6.5)", min: 5.5, max: 6.5, color: "#fee08b" },
    { label: "Good (6.5–7.5)", min: 6.5, max: 7.5, color: "#1a9850" },
    { label: "Too alkaline (>7.5)", min: 7.5, max: Infinity, color: "#4575b4" },
  ],
  Bulkdensity: [
    { label: "Very loose (<1.0)",     min: -Infinity, max: 1.0,     color: "#a50026" },
  { label: "Loose (1.0–1.2)",       min: 1.0,       max: 1.2,     color: "#d73027" },
  { label: "Moderate/optimal (1.2–1.4)", min: 1.2,   max: 1.4,     color: "#1a9850" },
  { label: "Dense (1.4–1.6)",       min: 1.4,       max: 1.6,     color: "#66c2a5" },
  { label: "Very dense (≥1.6)",     min: 1.6,       max: Infinity, color: "#4575b4" },
  ],
   C: [
    { label: "Very low (<0.5%)",   min: -Infinity, max: 0.5,     color: "#a50026" },
  { label: "Low (0.5–1%)",       min: 0.5,       max: 1.0,     color: "#d73027" },
  { label: "Moderate (1–2%)",    min: 1.0,       max: 2.0,     color: "#fee08b" },
  { label: "High (2–3%)",        min: 2.0,       max: 3.0,     color: "#66c2a5" },
  { label: "Very high (≥3%)",    min: 3.0,       max: Infinity, color: "#1a9850" },
  ],
  N: [
    { label: "Very low (<0.1%)",   min: -Infinity, max: 0.1,     color: "#a50026" },
  { label: "Low (0.1–0.2%)",     min: 0.1,       max: 0.2,     color: "#d73027" },
  { label: "Moderate (0.2–0.3%)", min: 0.2,       max: 0.3,     color: "#fee08b" },
  { label: "Good (0.3–0.5%)",    min: 0.3,       max: 0.5,     color: "#1a9850" },
  { label: "High (≥0.5%)",       min: 0.5,       max: Infinity, color: "#4575b4" },
  ],
  P: [
  { label: "Very low (<5 ppm)",   min: -Infinity, max: 5,   color: "#a50026" },
  { label: "Low (5–7 ppm)",       min: 5,         max: 7,   color: "#d73027" },
  { label: "Moderate (7–10 ppm)", min: 7,         max: 10,  color: "#fee08b" },
  { label: "Good (10–15 ppm)",    min: 10,        max: 15,  color: "#1a9850" },
  { label: "High (≥15 ppm)",      min: 15,        max: Infinity, color: "#4575b4" },
  ],
  K: [
    { label: "Very low (<120 ppm)",   min: -Infinity, max: 120,  color: "#a50026" },
  { label: "Low (120–160 ppm)",     min: 120,       max: 160,  color: "#d73027" },
  { label: "Moderate (160–220 ppm)",min: 160,       max: 220,  color: "#fee08b" },
  { label: "Good (220–300 ppm)",    min: 220,       max: 300,  color: "#1a9850" },
  { label: "High (≥300 ppm)",       min: 300,       max: Infinity, color: "#4575b4" },
  ],
  CEC: [
    { label: "Low (<10 cmol/kg)",     min: -Infinity, max: 10,   color: "#a50026" },
  { label: "Moderate (10–20)",      min: 10,        max: 20,   color: "#d73027" },
  { label: "High (20–35)",          min: 20,        max: 35,   color: "#fee08b" },
  { label: "Very High (35–45)",     min: 35,        max: 45,   color: "#1a9850" },
  { label: "Extremely High (≥45)",  min: 45,        max: Infinity, color: "#4575b4" },
  ],
  Soil_Texture: [
    { label: "Class 1 — Sand", min: 1, max: 2, color: "#a50026" },
    { label: "Class 2 — Loam", min: 2, max: 3, color: "#d73027" },
    { label: "Class 3 — Clay", min: 3, max: 4, color: "#fee08b" },
    { label: "Class 4 — Silt", min: 4, max: 5, color: "#1a9850" },
  ],
};

export function getSoilColor(property: string, value: number): string {
  const thresholds = SoilThresholds[property];
  if (!thresholds) return "#00000000"; // transparent
  const match = thresholds.find((t) => value >= t.min && value < t.max);
  return match ? match.color : "#00000000";
}